import uniqueId from "lodash/uniqueId";

export const getUniqueKey = () => {
  return uniqueId("fetcher-");
};
